import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const FailedIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
    <g fill="currentColor" stroke="currentColor" strokeWidth="0.5" transform="translate(-9, -10)">
      <path d="M25.255 24.208L25.0782 24.3848L25.255 24.5615L35.9776 35.2841L34.5146 36.7471L24.7735 27.006L24.7735 21.7635L34.5146 12.0224L35.9776 13.4854L25.255 24.208Z" />
      <path d="M21.9754 24.5615L22.1522 24.3848L21.9754 24.208L11.2529 13.4854L12.7159 12.0224L22.4569 21.7635V27.006L12.7159 36.7471L11.2529 35.2841L21.9754 24.5615Z" />
    </g>
  </svg>,
  'Failed'
);
